module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/CulinaryHistory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Culinary History of the Civilian Conservation Corps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("BREAKFAST")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("River Runnin’ Coffee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Graham Nut Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Sugar Coffee Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornmeal Mush")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple Fritters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Sausage Gravy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three-Ingredient Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moonstruck Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-Bran Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Citrusade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter1#S11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zwieback")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("LARGE-BATCH BREAKFAST DISHES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#S12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Hundred Doughnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#S13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornmeal Mush for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#S14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Toast for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#S15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baking Powder Biscuits for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#S16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-Bran Muffins for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("LUNCH AND SUPPER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sack Lunches for Thirty Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civilian Conservation Corps Vegetable Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Navy Bean Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chipped Beef on Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread and Butter Pickles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brunswick Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Divan Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bologna Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cabbage Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice Tomato Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six-Layer Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach Baked with Corn Flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn Oysters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Venison Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salmon Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American Chop Suey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three-Pound Meatloaf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snowflake Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fancy Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham and Celery Loaf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pittsburgh Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter, Bacon and Chili Sauce Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1930s Baked Mac and Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Porcupine Meatballs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Spaghetti")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zucchini Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sloppy Joes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asparagus Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calico Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oyster Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#S48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spaghetti with Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("LARGE-BATCH SUPPER RECIPES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brunswick Stew for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chipped Beef on Toast for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Stew for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Beans for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Roast for One Hundred Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Bean Salad for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potato Salad for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oxtail Soup for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lima Beans for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#S58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread Rolls for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("DESSERTS AND HOLIDAYS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mock Apple Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mashed Potato Fudge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S61",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Vanilla Coconut Mashed Potato Fudge Balls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S62",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Tennessee Christmas Mints")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S63",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Candied Fruit Balls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice Krispie Macaroons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poor Man’s Fruitcake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wacky Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S67",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fudge Frosting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S69",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Lemon Glaze")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apricot Upside-Down Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mincemeat Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prune Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn Flake Brown Betty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Soup Spice Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S75",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cream Cheese Frosting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Roly Poly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refrigerator Ginger Snaps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Cream Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Bottom Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hershey’s Mocha Devil’s Food Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S81",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chocolate Butter Icing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#S82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jell-O Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("LARGE-BATCH DESSERTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#S83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Hundred Molasses Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#S84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Hundred Oatmeal Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#S85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Cookies for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#S86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Apples for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#S87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bread Pudding for One Hundred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 78
// module chunks = 0